var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServersSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7766_53952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0V17.574H26V0Z",
    fill: "#E34A4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 4.97931H0V22H26V4.97931Z",
    fill: "#9E071E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 2.83789H0V20.4379H26V2.83789Z",
    fill: "#C53437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6309 11.6444L5.51595 17.6911H2.7843L8.89924 11.6444L2.7843 5.59766H5.51595L11.6309 11.6444Z",
    fill: "#4FC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.158 11.6444L7.04304 17.6911H4.30481L10.4263 11.6444L4.30481 5.59766H7.04304L13.158 11.6444Z",
    fill: "#4FC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3854 15.7841H13.7043V17.6977H20.3854V15.7841Z",
    fill: "#4FC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3854 14.9249H13.7043V16.8385H20.3854V14.9249Z",
    fill: "#4FC6E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7766_53952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServersSupport);
export default __webpack_public_path__ + "static/media/servers_support.18a0362cd7b8b8fb13a7de67f7c5301c.svg";
export { ForwardRef as ReactComponent };